import { defineStore } from "pinia";

export type MenuAccent = "emerald" | "cyan" | "violet" | "amber" | "indigo";

export interface Menu {
  icon?: string;
  type?: string;
  title: string;
  badge?: number;
  pageName?: string;
  subMenu?: Menu[];
  ignore?: boolean;
  roles?: string[];
  accent?: MenuAccent;
}

export interface MenuState {
  value: Array<Menu | string>;
}

/**
 * Nota: los ítems sin página real aún no llevan pageName.
 * Así no se marcan como activos al estar en "dashboard"
 * (antes todos apuntaban a dashboard y el menú se pintaba mal).
 */
export const useMenuStore = defineStore("menu", {
  state: (): MenuState => ({
    value: [
      {
        icon: "Home",
        pageName: "dashboard",
        title: "menu.dashboard",
      },
      {
        icon: "Users",
        title: "menu.section_family",
        roles: ["USER", "TECNICO", "ADMIN"],
        subMenu: [
          {
            icon: "UserRound",
            pageName: "my-family",
            title: "menu.my_family",
          },
          {
            icon: "Wallet",
            pageName: "family-fees",
            title: "menu.family_fees",
          },
          {
            icon: "CalendarDays",
            pageName: "my-activities",
            title: "menu.my_activities",
          },
          {
            icon: "BadgePercent",
            pageName: "family-benefits",
            title: "menu.family_benefits",
          },
          {
            icon: "FileText",
            pageName: "documents",
            title: "menu.documents",
          },
          {
            icon: "ShieldCheck",
            pageName: "my-privacy",
            title: "menu.privacy",
          },
          {
            icon: "History",
            pageName: "family-history",
            title: "menu.family_history",
          },
          {
            icon: "MessagesSquare",
            pageName: "family-chat",
            title: "menu.family_chat",
          },
          {
            icon: "Mails",
            pageName: "family-mailbox",
            title: "menu.family_mailbox",
            roles: ["TECNICO", "ADMIN"],
          },
        ],
      },
      {
        icon: "ClipboardList",
        title: "menu.section_management",
        roles: ["TECNICO", "ADMIN"],
        subMenu: [
          {
            icon: "UsersRound",
            pageName: "families",
            title: "menu.families",
          },
          {
            icon: "Wallet",
            pageName: "fees",
            title: "menu.fees",
          },
          {
            icon: "Receipt",
            pageName: "activity-fees",
            title: "menu.activity_fees",
          },
          {
            icon: "CalendarDays",
            pageName: "activities",
            title: "menu.activities",
          },
          {
            icon: "BadgePercent",
            pageName: "benefits",
            title: "menu.benefits",
          },
          {
            icon: "Lightbulb",
            pageName: "proposals",
            title: "menu.proposals",
          },
          {
            icon: "Banknote",
            pageName: "grants",
            title: "menu.grants",
          },
          {
            icon: "ClipboardCheck",
            pageName: "actions",
            title: "menu.actions",
          },
          {
            icon: "NotebookPen",
            pageName: "minutes",
            title: "menu.minutes",
          },
          {
            icon: "LayoutTemplate",
            pageName: "site-pages",
            title: "menu.static_pages",
          },
          {
            icon: "School",
            pageName: "school",
            title: "menu.school",
          },
          {
            icon: "Landmark",
            pageName: "anpa",
            title: "menu.anpa",
          },
        ],
      },
      {
        icon: "Mail",
        title: "menu.section_mail_chat",
        roles: ["TECNICO", "ADMIN"],
        subMenu: [
          {
            icon: "MessagesSquare",
            pageName: "chat",
            title: "menu.chat",
          },
          {
            icon: "Inbox",
            pageName: "mailbox",
            title: "menu.mailbox",
          },
          {
            icon: "Contact",
            pageName: "mailing-lists",
            title: "menu.mailing_lists",
          },
        ],
      },
      {
        icon: "Settings",
        title: "menu.section_admin",
        roles: ["ADMIN"],
        subMenu: [
          {
            icon: "SlidersHorizontal",
            pageName: "settings",
            title: "menu.settings",
          },
          {
            icon: "UserCog",
            pageName: "users",
            title: "menu.users",
          },
          {
            icon: "ScrollText",
            pageName: "system-logs",
            title: "menu.logs",
          },
        ],
      },
    ],
  }),
});
